import * as React from 'react'
import { useParams } from 'react-router-dom'

import { ContractsEmployeesContractVersionFragment } from 'generated/resources/graphql'
import moment from 'moment'

import {
  filterContractVersionsByCurrent,
  getUpcomingContractVersions,
} from 'modules/contracts/lib/utilsGraphql'
import contractVersionsPayrollPolicies, {
  ContractVersionsPayrollPoliciesProvider,
} from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import policies, { PoliciesProvider } from 'modules/payroll_bundle/store/collections/policies'

import Body from './_Body'

interface Props {
  graphqlContractVersions?: ContractsEmployeesContractVersionFragment[]
  employeeId: string
}

const Card = ({ graphqlContractVersions, employeeId }: Props) => {
  const { contractVersionId } = useParams()

  const getGraphqlContractVersion = React.useCallback(() => {
    const today = moment()
    const contractVersion = graphqlContractVersions?.find(
      (version) => version.id === String(contractVersionId)
    )

    if (contractVersion) return contractVersion

    const current = filterContractVersionsByCurrent(graphqlContractVersions ?? [], today)[0]

    if (current) return current

    return getUpcomingContractVersions(graphqlContractVersions ?? [], today)
  }, [contractVersionId, graphqlContractVersions])

  const graphqlContractVersion = getGraphqlContractVersion()

  return (
    <>
      <PoliciesProvider collection={policies}>
        <ContractVersionsPayrollPoliciesProvider collection={contractVersionsPayrollPolicies}>
          <Body
            employeeId={employeeId}
            graphqlContractVersions={graphqlContractVersions}
            graphqlContractVersion={graphqlContractVersion}
          />
        </ContractVersionsPayrollPoliciesProvider>
      </PoliciesProvider>
    </>
  )
}

export default Card
